import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import {
    Form, Input, Button, Icon, Row, Col,
} from 'antd';

import { AUTH_LOGIN } from '../../ActionTypes/ActionTypes';
import { setCookie } from '../../cookieStorage/CookieStorage';

const FormItem = Form.Item;

//axios.defaults.baseURL = 'http://localhost:3000';
//axios.defaults.baseURL = 'https://caredose-backend.herokuapp.com';
// axios.defaults.baseURL = 'http://192.168.86.243:3000';
// axios.defaults.baseURL = 'http://192.168.1.105:3000';
// axios.defaults.baseURL = 'http://10.0.1.22:3000';
axios.defaults.baseURL = process.env.REACT_APP_BAKE_URL;

class UnWrappedLogin extends Component {
    state = { loading: false };

    handleSubmit = (e) => {
        e.preventDefault();
        const { form, storeToken, history } = this.props;
        form.validateFields((err, values) => {
            if (!err) {
                this.setState({ loading: true });
                axios({
                    method: 'post',
                    url: '/user_token',
                    data: {
                        auth: {
                            email: values.userName,
                            password: values.password,
                        },
                    },
                })
                    .then((response) => {
                        storeToken(`JWT ${response.data.jwt}`);
                        sessionStorage.setItem(
                            'jwtToken',
                            `JWT ${response.data.jwt}`,
                        );
                        setCookie('jwtToken', `JWT ${response.data.jwt}`, 1);
                        this.setState({ loading: false }, () => {
                            history.push('/allUsers');
                        });
                        // setTimeout(() => this.props.history.push('/addOrder'), 2000);
                    })
                    .catch((error) => {
                        this.setState({ loading: false }, () => {
                            alert(error);
                        });
                    });
            }
        });
    };

    render() {
        const { form } = this.props;
        const { loading } = this.state;
        const { getFieldDecorator } = form;

        return (
            <div style={{ marginTop: '10%' }}>
                <Form
                    onSubmit={this.handleSubmit}
                    style={{ textAlign: 'center' }}
                >
                    <Row type="flex" justify="center">
                        <Col span={5}>
                            <FormItem style={{ textAlign: 'center' }}>
                                {getFieldDecorator('userName', {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'No tresspassing!!!',
                                        },
                                    ],
                                })(
                                    <Input
                                        prefix={(
                                            <Icon
                                                type="user"
                                                style={{
                                                    color: 'rgba(0,0,0,.25)',
                                                }}
                                            />
                                        )}
                                        placeholder="Login Id"
                                    />,
                                )}
                            </FormItem>
                        </Col>
                    </Row>

                    <Row type="flex" justify="center">
                        <Col span={5}>
                            <FormItem style={{ textAlign: 'center' }}>
                                {getFieldDecorator('password', {
                                    rules: [
                                        {
                                            required: true,
                                            message: '911 is on the way!!!',
                                        },
                                    ],
                                })(
                                    <Input
                                        prefix={(
                                            <Icon
                                                type="lock"
                                                style={{
                                                    color: 'rgba(0,0,0,.25)',
                                                }}
                                            />
                                        )}
                                        type="password"
                                        placeholder="Password"
                                    />,
                                )}
                            </FormItem>
                        </Col>
                    </Row>

                    <FormItem style={{ textAlign: 'center' }}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                        >
                            Log In
                        </Button>
                    </FormItem>
                </Form>
            </div>
        );
    }
}

const LoginForm = Form.create()(UnWrappedLogin);

const mapStateToProps = state => ({
    token: state.AppState.token,
});

const mapDispatchToProps = dispatch => ({
    storeToken: token => dispatch({ type: AUTH_LOGIN, token }),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);



// WEBPACK FOOTER //
// ./src/component/Login/Login.js